import { CIcon } from '~/icons/types'

export const ciKidScooter: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'm18.995 17.99-.67-5.945.935-.29a.5.5 0 0 0-.296-.955l-2.472.765a.5.5 0 0 0 .148.977.488.488 0 0 0 .148-.022l.563-.174.407 3.6h-5.466a.5.5 0 1 0 0 1h4.85l-1.668 2.014h-4.568a1.546 1.546 0 0 0-1.458-1.049 1.528 1.528 0 0 0-.426.067L6.16 4.24l.876-.27a.5.5 0 0 0-.295-.956l-2.472.765a.5.5 0 0 0 .148.977.488.488 0 0 0 .148-.022l.636-.197L8.139 18.64a1.535 1.535 0 0 0-.24.82 1.545 1.545 0 0 0 3.007.5h4.803a.502.502 0 0 0 .386-.18l1.844-2.226.052.46a1.553 1.553 0 1 0 1.004-.024Zm-9.547 2.02a.549.549 0 1 1 .548-.55.55.55 0 0 1-.548.55Zm9.085 0a.549.549 0 1 1 .549-.55.55.55 0 0 1-.549.55Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'kid-scooter',

  type: 'thin'
}
